export default __webpack_public_path__ + "static/media/search.da3387c7.svg";